import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css.css'
import preventReClick from './store/preventReClick' //防多次点击，重复提交
// import axios from 'axios'
// import VueAxios from 'vue-axios'
// Vue.prototype.$axios = axios;
// Vue.use(VueAxios, axios);

/*import axios*/
import ajax from './ajax/axios.js'
import  './ajax/axios'
Vue.prototype.$ajax = new ajax;
Vue.prototype.bus = new Vue();
Vue.prototype.layui = window.layui

router.beforeEach((to,from,next) =>{
  if(to.meta.title){
    document.title = to.meta.title
  }
  next();
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
